import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Segmento } from '../../_models/segmento';
import { NavService } from '../../_services/_nav.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SegmentosService } from '../../_services/segmentos.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { TipoOcupacionConfiguracionService } from '../../_services/tipo-ocupacion-configuracion.service';
import { forkJoin } from 'rxjs';
import { TipoOcupacionConfiguracion } from '../../_models/tipo-ocupacion-configuracion';
import { AppSettingService } from '../../_services/app-setting.service';
import { AdjuntoService } from '../../_services/adjunto.service';
import { SafeResourceUrl } from '@angular/platform-browser';
import { AppSettings } from '../../../proyect.conf';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { ConstanteService } from '../../_services/constante.service';
import { FileUpload } from 'primeng/fileupload';
import { SegmentoAdjuntoService } from '../../_services/segmento-adjunto.service';
import { SegmentoAdjunto } from '../../_models/segmento-adjunto';
import {SegmentoActividadesService} from '../../_services/segmento-actividades.service';
import {PaqueteSeguros} from '../../_models/paquete-seguros';
import {SegmentoActividad} from '../../_models/segmento-actividad';

@Component( {
  templateUrl: 'segmento-editar.component.html',
  selector: 'app-segmentos-editar'
} )
export class SegmentoEditarComponent implements OnInit {

  formulario: FormGroup;
  formularioVenta: FormGroup;
  segmentos: Segmento[] = [];
  segmento: Segmento;
  guardando: boolean;
  codExiste = false;
  codShivamExiste = false;
  submitted: boolean;
  submittedVenta: boolean;
  tabSeleccionado = 'INFO';
  ranIncorrecto = false;
  carInformacionInicial = true;
  carSeccionesOcupaciones = { actividad: false };
  lisTiposOcupaciones: TipoOcupacionConfiguracion[] = [];
  lisOcupaciones: SelectItem[] = [];
  lisEmpleador: SelectItem[] = [];
  lisUnidadProductiva: SelectItem[] = [];
  tipOcupacionSeleccionada: TipoOcupacionConfiguracion;
  validandoSegmento = false;
  segmentoTemp = null;
  valorVenta = false;
  rangoDesdeValido = true;
  guardandoVenta = false;
  segmentoHabilitar: any = {
    segmentosActividadesList: [],
    segmentosActivosList: [],
    segmentosSectoresList: [],
    segmentosTiposContratosList: [],
    segmentosEmpleadosList: [],
    segmentosIngresos: null,
    segmentosIngresosList: [],
    segmentosNivelesEndeudamientosList: [],
    indicadorVenta: false,
    segmentosList: []
  };
  carImagen = false;
  imagen: SafeResourceUrl;
  svcThUrl = AppSettings.rutServiciosADJ + '/api/adjuntos';
  nomArchivo: string;
  maxSize: number;
  @ViewChild('adjunto') adjunto: FileUpload;
  segAdjunto: SegmentoAdjunto;
  constanteNIVEND: any;

  constructor( private navServicio: NavService,
               private router: Router,
               private route: ActivatedRoute,
               private formBuilder: FormBuilder,
               private segmentosServicio: SegmentosService,
               private adjService: AdjuntoService,
               private tipOcupacionesConfiguracionServicio: TipoOcupacionConfiguracionService,
               private confirmacionServicio: ConfirmationService,
               private autServicio: AutenticacionService,
               private conConstanteServicio: ConstanteService,
               private segAdjuntoServicio: SegmentoAdjuntoService,
               public appSettingService: AppSettingService,
               private segmentoActividadesService : SegmentoActividadesService) {
  }

  ngOnInit(): void {
    this.segmentoTemp = this.segmentoHabilitar;
    this.lisEmpleador.push( { label: 'Si', value: true } );
    this.lisEmpleador.push( { label: 'No', value: false } );
    this.lisUnidadProductiva.push( { label: 'Si', value: true } );
    this.lisUnidadProductiva.push( { label: 'No', value: false } );
    this.route.params.subscribe( ( params: Params ) => {

      forkJoin( this.segmentosServicio.listado(), this.tipOcupacionesConfiguracionServicio.listado(), this.conConstanteServicio.getByCode( 'FSIZE' ),
        this.conConstanteServicio.getByCode('NIVEND') ).subscribe( ( [ lisSegmentos, lisTipoOcupacion, tamMaximo, contNivend ] ) => {
        this.lisTiposOcupaciones = lisTipoOcupacion;
        this.constanteNIVEND = contNivend;
        this.segmentos = lisSegmentos;
        this.maxSize = ( tamMaximo && tamMaximo.valor ) ? Number( tamMaximo.valor ) : 50000000;
        if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
          this.segmento = this.segmentos.find( x => x.idSegmento == params[ 'id' ] );
          this.segAdjuntoServicio.obtenerPorIdSegmento( params[ 'id' ] ).subscribe( segAdjunto => {
            this.segAdjunto = segAdjunto;
            if ( this.segAdjunto && this.segAdjunto.indicadorHabilitado ) {
              this.cargarAdjunto( this.segAdjunto.idAdjunto, this.segAdjunto.nombreArchivo );
            }
            this.cargarLista();
            this.cargarFormulario();
            this.obtenerTipoOcupacion();
          } );

        } else {
          this.cargarLista();
          this.cargarFormulario();
        }
      } );
    } );
  }

  cambioOcupacion( event: any ) {
    this.f.idTipoOcupacionConfiguracion.setValue( event.value );
    this.obtenerTipoOcupacion( true );
  }

  obtenerTipoOcupacion( event?: boolean ) {
    let a: any;
    if ( event ) {
      a = this.lisTiposOcupaciones.find( x => x.idTipoOcupacionConfiguracion === this.f.idTipoOcupacionConfiguracion.value );
    } else {
      a = this.lisTiposOcupaciones.find( x => x.idTipoOcupacionConfiguracion === this.segmento.idTipoOcupacionConfiguracion );
    }
    if ( a ) {

      if (!a.indicadorIngresos){
        this.segmentoActividadesService.listadoActividadesOcupacion( a.idTipoOcupacionConfiguracion ).
        subscribe( paquete => {
          paquete.map( ( s: SegmentoActividad ) => {
            if(s.idSegmento !== this.segmento.idSegmento){
              a.indicadorIngresos = true;
            }
          } );
        } );
      }

      if ( !this.tipOcupacionSeleccionada || a.idTipoOcupacionConfiguracion != this.tipOcupacionSeleccionada.idTipoOcupacionConfiguracion ) {
        this.setearSecciones();
      }
      this.tipOcupacionSeleccionada = a;
      this.cambioTabSeleccionado( 0 );
      if ( !this.tipOcupacionSeleccionada.indicadorEmpleador ) {
        if ( event ) {
          this.f.indicadorEmpleador.setValue( null );
        } else {
          this.segmento.indicadorEmpleador = null;
        }
        this.f.indicadorEmpleador.clearValidators();
        this.f.indicadorEmpleador.setErrors( null );
      } else {
        this.f.indicadorEmpleador.setValidators( [ Validators.required ] );
        this.f.indicadorEmpleador.updateValueAndValidity();
      }


      if ( !this.tipOcupacionSeleccionada.indicadorUnidadProductiva ) {
        this.f.indicadorUnidadProductiva.setValidators( [] );
        if ( event ) {
          this.f.indicadorUnidadProductiva.setValue( null );
        } else {
          this.segmento.indicadorUnidadProductiva = null;
        }
      } else {
        this.f.indicadorUnidadProductiva.setValidators( [ Validators.required ] );
        this.f.indicadorUnidadProductiva.updateValueAndValidity();
      }

    } else {
      this.tipOcupacionSeleccionada = null;
      this.setearSecciones();
    }
  }

  setearSecciones() {
    this.carSeccionesOcupaciones.actividad = false;
  }

  cargarLista() {
    this.lisTiposOcupaciones.map( ( s: TipoOcupacionConfiguracion ) => {
      if ( s.indicadorHabilitado ) {
        this.lisOcupaciones.push( { label: s.nombreTipoOcupacion, value: s.idTipoOcupacionConfiguracion } );
      }
    } );
  }

  cargarFormulario() {
    this.formularioVenta = this.formBuilder.group( {
      idSegmento: [ this.segmento ? this.segmento.idSegmento : null ],
      montoMinimo: [ null, [ Validators.required ] ],
      montoMaximo: [ null, [ Validators.required ] ],
    } );

    this.formulario = this.formBuilder.group( {
      idSegmento: [ this.segmento ? this.segmento.idSegmento : null ],
      codigo: [ this.segmento ? this.segmento.codigo : null, [ Validators.required, Validators.maxLength( 6 ) ] ],
      codigoShivam: [ this.segmento ? this.segmento.codigoShivam : null, [ Validators.required, Validators.maxLength( 6 ) ] ],
      nombre: [ this.segmento ? this.segmento.nombre : null, [ Validators.required, Validators.maxLength( 45 ) ] ],
      descripcion: [ this.segmento ? this.segmento.descripcion : null, Validators.maxLength( 1000 ) ],
      indicadorValorVenta: [ this.segmento ? this.segmento.indicadorValorVenta : false ],
      indicadorHabilitado: [ this.segmento ? this.segmento.indicadorHabilitado : false ],
      indicadorContinuarVisita: [ this.segmento ? this.segmento.indicadorContinuarVisita : false ],
      indicadorEmpleador: [ this.segmento ? this.segmento.indicadorEmpleador === true ? true : this.segmento.indicadorEmpleador === false ? false : null : null ],
      indicadorUnidadProductiva: [ this.segmento ? ( this.segmento.indicadorUnidadProductiva === true ? true : ( this.segmento.indicadorEmpleador === false ? false : null ) ) : null ],
      auditoriaUsuario: [ this.segmento ? this.segmento.auditoriaUsuario : null ],
      auditoriaFecha: [ this.segmento ? this.segmento.auditoriaFecha : null ],
      idTipoOcupacionConfiguracion: [ this.segmento ? this.segmento.idTipoOcupacionConfiguracion : null, Validators.required ],
      nombreTipoOcupacion: [ this.segmento ? this.segmento.nombreTipoOcupacion : null ],
      idAdjunto: [ (this.segAdjunto && this.segAdjunto.indicadorHabilitado) ? this.segAdjunto.idAdjunto : null ]
    } );
    this.carInformacionInicial = false;

  }


  get f() {
    return this.formulario.controls;
  }

  get fv() {
    return this.formularioVenta.controls;
  }

  onSubmit() {
    this.submitted = true;
    // this.validarRango();
    if ( this.formulario.valid && !this.codExiste && !this.codShivamExiste ) {
      this.guardando = true;
      const formulario = this.formulario.value;
      if ( formulario.idSegmento ) {
        this.segmentosServicio.actualizar( formulario ).subscribe( async res => {
          this.segmento = formulario;
          await this.validarAdjuntos( formulario );
          this.obtenerTipoOcupacion();
          this.navServicio.setMesage( 2 );
          this.tabSeleccionado = 'OCUPACION';
          this.guardando = false;
        }, e => {
          this.guardando = false;
          this.navServicio.setMesage( 3 );
        } );
      } else {
        this.segmentosServicio.agregar( formulario ).subscribe( async res => {
          formulario.idSegmento = res.idSegmento;
          await this.validarAdjuntos( formulario );
          this.segmento = formulario;
          this.f.idSegmento.setValue( res.idSegmento );
          this.obtenerTipoOcupacion();
          this.guardando = false;
          this.navServicio.setMesage( 2 );
          this.router.navigate( [ 'apl/segmentos/actualizar/' + this.segmento.idSegmento ] );
          this.tabSeleccionado = 'OCUPACION';
        }, e => {
          this.guardando = false;
          this.navServicio.setMesage( 3 );
        } );
      }
    }
  }

  async validarAdjuntos( segmento: any ) {
    if ( segmento.idAdjunto && ( !this.segAdjunto || this.segAdjunto.idAdjunto !== segmento.idAdjunto ) ) {
      const registro = this.segAdjunto ? this.segAdjunto : {} as SegmentoAdjunto;
      registro.indicadorHabilitado = true;
      registro.idSegmento = segmento.idSegmento;
      registro.idAdjunto = segmento.idAdjunto;
      this.segAdjunto = await ( registro.idSegmentoAdjunto ? this.segAdjuntoServicio.actualizar( registro ) : this.segAdjuntoServicio.crear( registro ) ).toPromise();
      this.segAdjunto.nombreArchivo = this.nomArchivo;
    } else if (!segmento.idAdjunto && this.segAdjunto && this.segAdjunto.indicadorHabilitado ) {
      this.segAdjunto.indicadorHabilitado = false;
      await this.segAdjuntoServicio.actualizar( this.segAdjunto ).toPromise();
    }
    return true;
  }

  goBack() {
    if ( this.formulario.dirty ) {
      this.confirmacionServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_SALIRSINGUARDAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'segmento',
        accept: () => {
          this.router.navigate( [ 'apl/segmentos' ] );
        }
      } );
    } else {
      this.router.navigate( [ 'apl/segmentos' ] );
    }
  }

  abrirAcordeon( evento: any ) {
    switch ( evento.index ) {
      case 0: {
        this.tabSeleccionado = 'INFO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'OCUPACION';
        break;
      }
      case 2: {
        this.tabSeleccionado = 'PRODUCTO';
        break;
      }
      default: {
        break;
      }
    }
  }

  cambiarTabSeleccionado( tab: string ) {
    this.tabSeleccionado = tab;
  }

  validarCodigo() {
    this.codExiste = this.segmentos.find( x => x.codigo === this.f.codigo.value && ( !this.segmento || this.segmento.idSegmento !== x.idSegmento ) ) ? true : false;
  }

  validarCodigoShivam() {
    this.codShivamExiste = this.segmentos.find( x => x.codigoShivam === this.f.codigoShivam.value && ( !this.segmento || this.segmento.idSegmento !== x.idSegmento ) ) ? true : false;
  }


  cambioValorVenta( checked: boolean ) {
    this.f.montoMinimo.clearValidators();
    this.f.montoMaximo.clearValidators();
    if ( checked ) {
      this.f.montoMaximo.setValidators( [ Validators.required, Validators.maxLength( 7 ) ] );
      this.f.montoMinimo.setValidators( [ Validators.required, Validators.maxLength( 7 ) ] );
    } else {
      this.f.montoMinimo.setValue( null );
      this.f.montoMinimo.setValidators( [] );
      this.f.montoMaximo.setValue( null );
      this.f.montoMaximo.setValidators( [] );
    }
  }

  validarRango() {
    const inferior = this.f.montoMinimo.value;
    const superior = this.f.montoMaximo.value;
    this.ranIncorrecto = ( inferior && superior && Number( inferior ) >= Number( superior ) ) ? true : false;
  }

  actualizarIndicadores() {
    if ( this.ranIncorrecto ) {
      this.ranIncorrecto = false;
    }
  }

  cambioTabSeleccionado( index: number ) {
    let indice = index;

    if ( !this.tipOcupacionSeleccionada.indicadorManejaActividades && indice >= 0 ) {
      indice++;
    }
    switch ( indice ) {
      case 0:
        this.carSeccionesOcupaciones.actividad = true;
        break;
      case 1:
        break;
      default:
    }
  }

  habilitarSegmento() {
    if ( this.segmento.indicadorHabilitado ) {
      this.segmento.indicadorHabilitado = false;
      this.segmentosServicio.actualizar( this.segmento ).subscribe( res => {
        this.navServicio.setMesage( 2 );
        this.router.navigate( [ 'apl/segmentos' ] );
      }, error1 => {
        this.navServicio.setMesage( 3 );
      } );
    } else {
      this.validandoSegmento = true;
      this.segmentoTemp.indicadorVenta = false;
      this.segmentoTemp.indicadorEmpleador = false;
      this.segmentoTemp.indicadorUnidadProductiva = false;
      this.segmentoTemp.segmentosActivosList = [];
      this.segmentoTemp.segmentosEmpleadosList = [];
      this.segmentoTemp.segmentosNivelesEndeudamientosList = [];
      this.segmentoTemp.segmentosSectoresList = [];
      this.segmentoTemp.segmentosTiposContratosList = [];
      this.segmentoTemp.segmentosIngresos = null;
      this.segmentoTemp.segmentosIngresosList = [];
      this.segmentosServicio.validarConfiguracionSegmento( this.segmento.idSegmento ).subscribe( res => {
        if ( res ) {
          this.segmentosServicio.habilitarSegmento( this.segmento.idSegmento ).subscribe( seg => {
            this.segmentoTemp.indicadorVenta = seg.indicadorVenta;
            this.segmentoTemp.indicadorEmpleador = seg.indicadorEmpleador;
            this.segmentoTemp.indicadorUnidadProductiva = seg.indicadorUnidadProductiva;
            this.segmentoTemp.segmentosActivosList = seg.segmentosActivosList;
            this.segmentoTemp.segmentosEmpleadosList = seg.segmentosEmpleadosList;
            this.segmentoTemp.segmentosNivelesEndeudamientosList = seg.segmentosNivelesEndeudamientosList;
            this.segmentoTemp.segmentosSectoresList = seg.segmentosSectoresList;
            this.segmentoTemp.segmentosTiposContratosList = seg.segmentosTiposContratosList;
            this.segmentoTemp.segmentosIngresos = seg.segmentosIngresosList;
            this.segmentoTemp.segmentosList = seg.segmentosList;
            this.segmentoTemp.segmentosIngresosList.push( seg.segmentosIngresosList );
            this.validandoSegmento = false;
            this.segmento.indicadorHabilitado = true;
            this.segmentosServicio.actualizar( this.segmento ).subscribe( res => {
              this.navServicio.setMesage( 2 );
              this.router.navigate( [ 'apl/segmentos' ] );
            }, error1 => {
              this.navServicio.setMesage( 3 );
            } );

          }, error1 => {
            this.validandoSegmento = false;
          } );
        } else {
          this.navServicio.setMesage( 0, {
            severity: 'info',
            summary: 'Información',
            detail: 'Debe tener al menos un registro en cada seccion para habilitar el segmento'
          } );
          this.cambiarTabSeleccionado( 'OCUPACION' );
          this.validandoSegmento = false;
        }
      }, error1 => {
        this.validandoSegmento = false;
      } );
    }
    // this.validandoSegmento = true;
    // setTimeout( () => {
    //   this.valorVenta = true;
    //   this.validandoSegmento = false;
    //   this.fv.idSegmento.setValue( this.segmento.idSegmento );
    //   this.segmentoTemp = this.cargarDatos();
    // }, 1000 );
    // this.navServicio.setMesage( 0, {
    //   severity: 'info',
    //   summary: 'Información',
    //   detail: 'Editar configuraciones para editar segmento.'
    // }, false );
    // this.cambiarTabSeleccionado( 'OCUPACION' );
  }

  contruirObjeto(): boolean {
    if ( this.segmentoTemp.segmentosActivosList === null ) {
      this.segmentoTemp.segmentosActivosList = [];
    }
    if ( this.segmentoTemp.segmentosEmpleadosList === null ) {
      this.segmentoTemp.segmentosEmpleadosList = [];
    }
    if ( this.segmentoTemp.segmentosNivelesEndeudamientosList === null ) {
      this.segmentoTemp.segmentosNivelesEndeudamientosList = [];
    }
    if ( this.segmentoTemp.segmentosSectoresList === null ) {
      this.segmentoTemp.segmentosSectoresList = [];
    }
    if ( this.segmentoTemp.segmentosTiposContratosList === null ) {
      this.segmentoTemp.segmentosTiposContratosList = [];
    }
    if ( !this.segmentoTemp.indicadorVenta && !this.segmentoTemp.indicadorEmpleador &&
      !this.segmentoTemp.indicadorUnidadProductiva && this.segmentoTemp.segmentosActivosList.length <= 0
      && this.segmentoTemp.segmentosEmpleadosList.length <= 0
      && this.segmentoTemp.segmentosNivelesEndeudamientosList.length <= 0
      && this.segmentoTemp.segmentosSectoresList.length <= 0 && this.segmentoTemp.segmentosTiposContratosList.length <= 0
      && this.segmentoTemp.segmentosIngresos === null ) {
      return true;
    } else {
      return false;
    }
  }

  onSubmitValorVenta() {
    this.submittedVenta = true;
    const data = this.formularioVenta.value;
    if ( this.validarValores() ) {
      if ( this.formularioVenta.valid ) {
        this.segmento.montoMaximo = data.montoMaximo;
        this.segmento.montoMinimo = data.montoMinimo;
        this.segmento.indicadorHabilitado = true;
        this.segmentosServicio.actualizar( this.segmento ).subscribe( res => {
          this.navServicio.setMesage( 2 );
          this.router.navigate( [ 'apl/segmentos' ] );
        }, error1 => {
          this.navServicio.setMesage( 3 );
        } );
      }
    } else {
      this.navServicio.setMesage( 0, {
        severity: 'error',
        summary: 'Datos',
        detail: 'Este rango de ventas esta contenido en otro.'
      } );
    }
  }

  validarValor( event: any, desde: boolean ) {
    const minimo = this.formularioVenta.controls.montoMinimo.value;
    const maximo = this.formularioVenta.controls.montoMaximo.value;
    if ( desde && maximo ) {
      if ( Number( minimo ) >= Number( maximo ) ) {
        this.rangoDesdeValido = false;
      } else {
        this.rangoDesdeValido = true;
      }
    } else if ( !desde && minimo ) {
      if ( Number( minimo ) >= Number( maximo ) ) {
        this.rangoDesdeValido = false;
      } else {
        this.rangoDesdeValido = true;
      }
    }
  }

  validarValores(): boolean {
    const minimo = this.formularioVenta.controls.montoMinimo.value;
    const maximo = this.formularioVenta.controls.montoMaximo.value;
    const idSegmento = this.formularioVenta.controls.idSegmento.value;
    const dato1 = this.segmentoHabilitar.segmentosList.find( x => x.montoMinimo <= Number( minimo ) && x.montoMaximo >= Number( minimo ) );
    const dato2 = this.segmentoHabilitar.segmentosList.find( x => x.montoMinimo <= Number( maximo ) && x.montoMaximo >= Number( maximo ) );
    if ( ( dato1 && dato1.idSegmento !== idSegmento ) || ( dato2 && dato2.idSegmento !== idSegmento ) ) {
      return false;
    } else {
      return true;
    }
  }

  onBeforeSend( event: any ) {
    this.carImagen = true;
    this.adjService.cargarArchivo( event, this.nomArchivo, 'Segmento' );
  }

  onUpload( event: any ) {
    const respuesta = event.originalEvent.body
    if ( respuesta.idAdjunto ) {
      this.f.idAdjunto.setValue( respuesta.idAdjunto );
      this.f.idAdjunto.markAsDirty();
      this.carImagen = false;
    }
  }

  onSelect( event: any, file: any ) {
    if ( this.adjunto.msgs.length === 0 ) {
      this.nomArchivo = file[ 0 ].name;
      this.cargarReaderImagen( file[ 0 ] );
    } else {
      this.navServicio.setMesageArray( this.adjunto.msgs );
    }

  }

  cargarReaderImagen( file: any ) {
    const reader = new FileReader();
    reader.addEventListener( 'load', () => {
      this.imagen = reader.result;
    }, false );
    if ( file ) {
      reader.readAsDataURL( file );
    }
  }

  cargarAdjunto( idAdjunto: string, nombre: string ) {
    this.carImagen = true;
    this.adjService.descargarArchivo( idAdjunto ).subscribe( adjunto => {
      this.nomArchivo = nombre;
      this.cargarReaderImagen( adjunto );
      this.carImagen = false;
    }, error => {
      this.carImagen = false;
    } );
  }

  cancelarAdjunto() {
    this.f.idAdjunto.setValue( null );
    this.f.idAdjunto.markAsDirty();
    this.imagen = null;
  }

  error() {
    console.log( 'error' );
  }


}
